import Folder from "../component/Folder";

const Projects = () => {
  return (
    <div className="projects">
      <Folder title="Sand Box" full="true" to="/projects/sandbox" tabIn="1" />
    </div>
  );
};

export default Projects;
